// ** admin routes **
import AppRoutes from './admin/app';
import BannerRoutes from './admin/banner';
import BlogRoutes from './admin/blog';
import CategoryImport from './admin/category';
import CouponRoutes from './admin/coupon';
import ExtrasRoutes from './admin/extras';
import FaqRoutes from './admin/faq';
import FoodRoutes from './admin/food';
import GalleryRoutes from './admin/gallery';
import MediaLibraryRoutes from './admin/media-library';
import ActivitiesRoutes from './admin/activities';
import LanguagesRoutes from './admin/language';
import NotificationRoutes from './admin/notification';
import OrderRoutes from './admin/order';
import ReviewRoutes from './admin/reviews';
import SettingsRoutes from './admin/settings';
import UsersRoutes from './admin/user';
import ReportRoutes from './admin/report';
import PropertiesRoutes from './admin/property';
import RepairRoutes from './admin/repair';
import AdminMessagesRoutes from './admin/admin-messages';
import SpecialOffersRoutes from './admin/special-offers';
import TrackingRoutes from './admin/tracking';
import BrandRoutes from './admin/brand';
import TagRoutes from './admin/tag';
import StorefrontHomeLayoutRoutes from './admin/storefront-home-layout';
import StorefrontHomeLayoutUsedRoutes from './admin/storefront-home-layout-used';
import HeaderQuickActionRoutes from './admin/header-quick-action';
import NoticeBoardRoutes from './admin/notice-board';
import TeamMemberRoutes from './admin/team-member';
import TradeInRoutes from './admin/trade-in';
import CronJobsRoutes from './admin/cron-jobs';
import UsedRoutes from './admin/used';
import EmailLogRoutes from './admin/email-log';
import WhatsappRoutes from './admin/whatsapp';
import EmailPreviewRoutes from './admin/email-preview';
// Built, but never reachable: these three route files existed with working
// views and services and simply were not imported here.
import RefundsRoutes from './admin/refunds';
import MessageSubscriberRoutes from './admin/message-subscriber';
import LandingPageRoutes from './admin/landing-page';
import InventoryRoutes from './admin/inventory';
import AnalyticsRoutes from './admin/analytics';
import WorkspaceRoutes from './admin/workspace';
import MarketingPopupRoutes from './admin/marketing-popup';
import PushNotificationRoutes from './admin/push-notification';

// ** Merge Routes
const AllRoutes = [
  ...AppRoutes,
  ...BannerRoutes,
  ...BlogRoutes,
  ...CategoryImport,
  ...CouponRoutes,
  ...ExtrasRoutes,
  ...FaqRoutes,
  ...FoodRoutes,
  ...GalleryRoutes,
  ...MediaLibraryRoutes,
  ...ActivitiesRoutes,
  ...LanguagesRoutes,
  ...NotificationRoutes,
  ...OrderRoutes,
  ...ReviewRoutes,
  ...SettingsRoutes,
  ...UsersRoutes,
  ...ReportRoutes,
  ...PropertiesRoutes,
  ...RepairRoutes,
  ...AdminMessagesRoutes,
  ...SpecialOffersRoutes,
  ...TrackingRoutes,
  ...BrandRoutes,
  ...TagRoutes,
  ...NoticeBoardRoutes,
  ...TeamMemberRoutes,
  ...StorefrontHomeLayoutRoutes,
  ...StorefrontHomeLayoutUsedRoutes,
  ...HeaderQuickActionRoutes,
  ...TradeInRoutes,
  ...CronJobsRoutes,
  ...UsedRoutes,
  ...EmailLogRoutes,
  ...WhatsappRoutes,
  ...EmailPreviewRoutes,
  ...RefundsRoutes,
  ...MessageSubscriberRoutes,
  ...LandingPageRoutes,
  ...InventoryRoutes,
  ...AnalyticsRoutes,
  ...WorkspaceRoutes,
  ...MarketingPopupRoutes,
  ...PushNotificationRoutes,
];

export { AllRoutes };
